/**
 * Geolocation utilities
 * Position is only requested on user action (never on page load)
 */

export interface UserLocation {
  lat: number;
  lng: number;
}

export interface GeolocationResult {
  location?: UserLocation;
  error?: string;
}

const GEOLOCATION_OPTIONS: PositionOptions = {
  enableHighAccuracy: false,
  timeout: 10000,
  maximumAge: 60000, // Cache for 1 minute
};

export function requestUserLocation(): Promise<GeolocationResult> {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({ error: "Din webbläsare stödjer inte platsåtkomst." });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          location: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          },
        });
      },
      (error) => {
        let message: string;
        switch (error.code) {
          case error.PERMISSION_DENIED:
            message = "Platsåtkomst nekades. Tillåt platsåtkomst i webbläsaren.";
            break;
          case error.POSITION_UNAVAILABLE:
            message = "Kunde inte hitta din position.";
            break;
          case error.TIMEOUT:
            message = "Det tog för lång tid att hämta din position.";
            break;
          default:
            message = "Kunde inte hämta din position. Prova igen.";
        }
        resolve({ error: message });
      },
      GEOLOCATION_OPTIONS
    );
  });
}
